import { decorate, observable, action, computed } from "mobx";
// import { SnackbarProvider, useSnackbar } from 'notistack';

class NotificationStore {
  open = false;
  message = "";
  variant = "success";
  constructor(appStore) {
    this.appStore = appStore;
  }

  showNotification = (message, variant = "success") => {
    let me = this,
      timeout = 0;

    if (me.open) {
      me.open = false;
      timeout = 500;
    }
    setTimeout(() => {
      me.open = true;
      me.message = message;
      me.variant = variant;
    }, timeout);
  };

  setConfirm(confirm) {
    this.confirm = confirm;
  }
}

decorate(NotificationStore, {
  open: observable,
  message: observable,
  variant: observable,
  // isDialogOpen: observable,

  // createPack: action,
  // showDialog: action
});

export default NotificationStore;
